
import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

@Component({
  components: { Header, Footer }
})
export default class App extends Vue {
  protected render() {
    return (
      <div id="app">
        <Header />
        <main>
          <div class="main-wrap">
            <router-view name="main" />
            <router-view name="slideBar" />
          </div>
        </main>
        <Footer />
      </div>
    );
  }
}
